var _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "24.4mm",
    height: "8.2mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2440 820",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2A2A2A",
      strokeWidth: 26.46
    },
    d: "M135 13l2170 0c66,0 119,53 119,119l0 556c0,66 -53,119 -119,119l-2170 0c-66,0 -119,-53 -119,-119l0 -556c0,-66 53,-119 119,-119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A2A2A",
      fillRule: "nonzero"
    },
    d: "M622 411c22,-11 36,-32 36,-60 0,-44 -36,-72 -102,-72l-130 0 0 276 138 0c71,0 108,-27 108,-75 0,-36 -20,-59 -50,-69zm-72 -92c36,0 56,13 56,38 0,26 -20,38 -56,38l-72 0 0 -76 72 0zm11 196l-83 0 0 -80 83 0c38,0 59,12 59,40 0,28 -21,40 -59,40zm161 40l50 0 0 -293 -50 0 0 293zm209 3c66,0 113,-45 113,-108 0,-64 -47,-108 -113,-108 -65,0 -112,44 -112,108 0,63 47,108 112,108zm0 -42c-35,0 -62,-26 -62,-66 0,-41 27,-66 62,-66 36,0 63,25 63,66 0,40 -27,66 -63,66zm257 42c41,0 74,-18 90,-49l-38 -23c-12,21 -31,30 -52,30 -37,0 -64,-25 -64,-66 0,-41 27,-66 64,-66 21,0 40,9 52,29l38 -22c-16,-32 -49,-49 -90,-49 -67,0 -114,44 -114,108 0,63 47,108 114,108zm290 -3l60 0 -96 -122 88 -89 -59 0 -103 95 0 -177 -49 0 0 293 49 0 0 -56 37 -34 73 90zm282 -104c0,-66 -45,-109 -107,-109 -63,0 -109,45 -109,108 0,63 46,108 117,108 36,0 66,-12 85,-34l-27 -31c-15,16 -34,23 -57,23 -37,0 -63,-20 -69,-50l166 0c0,-5 1,-11 1,-15zm-107 -70c32,0 56,21 60,52l-120 0c5,-31 28,-52 60,-52zm311 -119l0 108c-16,-19 -40,-28 -68,-28 -61,0 -106,42 -106,108 0,65 45,108 106,108 29,0 54,-10 70,-30l0 27 48 0 0 -293 -50 0zm-62 254c-35,0 -62,-26 -62,-66 0,-41 27,-66 62,-66 36,0 63,25 63,66 0,40 -27,66 -63,66z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.70e8de1ca624ae106807591b321a5953.svg";
export { ForwardRef as ReactComponent };